import * as React from "react";

import "./denial-confirmation-modal.scss";

import {cs}                      from "@Common/react/chain-services";
import {UseState}                from "@Common/react/use-state";
import {DeprecatedModalService2} from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";
import {Link} from "@Common/react/cst2";
import {Static2} from "@Common/react/static-2";

export const DenialConfirmationModal = ({next: rootNext}:{
    next    : Link<React.ReactNode, {
        show    : (props:{
            confirm  : () => Promise<{success: boolean, error?: React.ReactNode}>,
            onClose ?: () => void,
        }) => void,
    }>
}) => cs(
    ["closeListenerStatic", ({}, next) => Static2({next})],
    ["modal", ({closeListenerStatic: {get: getCloseListener, set: setCloseListener}}, next) => <DeprecatedModalService2 {...{
        render: ({confirm, onClose}, rm) => ({
            size: "small",
            content: next({
                close: () => {onClose?.(); rm()},
                confirm,
            }),
            onPassiveClose: onClose,
        }),
        hideCloseButton: true,
        next: rootNext,
    }}/>],

    ["confirmError", (_, next) => UseState({next})],
    ["confirming", (_, next) => UseState({next})],
    ({modal, confirming, confirmError}) => (
        <div className="deny-cart-modal-01z" xd-qa-type="modal" xd-qa-name="deny modal">
            <div className="message" xd-qa-type="label" xd-qa-name="deny message">
                {confirming.value ? "Processing request, please wait..." : "Are you sure you want to send this request back to the user?"}
            </div>

            {confirmError.value && (
                <div className="error" xd-qa-type="label" xd-qa-name="error message">
                    {confirmError.value}
                </div>
            )}

            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: () => modal.close(),
                    "xd-qa-type": "button",
                    "xd-qa-name": "cancel",
                }}>
                    Cancel
                </button>

                <button {...{
                    className: "ok",
                    disabled: confirming.value,
                    onClick: async () => {
                        confirming.onChange(true);
                        confirmError.onChange(null);

                        const {success, error} = await modal.confirm();
                        if (success) {
                            modal.close();
                        } else {
                            confirmError.onChange(error);
                            confirming.onChange(false);
                        }
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "ok",
                }}>
                    OK
                </button>
            </div>
        </div>
    )
);
